<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="streamed" @selected="switchTab"></TabsWidget>
      <div class="tab-options"></div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="streamed-item" v-for="(item, index) in streamed_data" :key="index" @click="selectReport(item)">
          <div v-if="item.image" class="streamed-item-image">
            <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + item.image
              " />
          </div>
          <div v-else class="streamed-item-image"></div>
          <div class="streamed-item-content">
            <h3>{{ item.title }}</h3>
          </div>
        </div>
      </div>
      <div v-if="selected_report" class="rigth-panel active_session">
        <div class="rigth-panel-header">

          <div class="tabs-widget">
            <div class="tab-item" :class="{ active: streamTab == 'overview' }"
              @click="switchStreamTab('overview')">OVERVIEW</div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: streamTab == 'payed_transations' }"
              @click="switchStreamTab('payed_transations')">PAYED TRANSATIONS</div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: streamTab == 'free_tickets' }"
              @click="switchStreamTab('free_tickets')">
              INVITATION TICKETS
            </div>
          </div>

        </div>

        <div class="rigth-panel-body" :class="{ expand: streamTab == 'overview' }" v-if="streamTab == 'overview'">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">OVERVIEW</h2>
            <div class="rigth-panel-body-header-actions">
              <b-select v-model="selected_currency" @input="onCurrencyChange" class="filter-currency-input"
                placeholder="Select Currency">
                <option value="RWF">RWF</option>
                <option value="USD">USD</option>
              </b-select>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="rigth-panel-top">
            <widgetCounter title="TOTAL BALANCE" :value="$formatMoney(
              reports.tax_balance + reports.earned_amount,
              (decimalCount = 2),
              (decimal = '.'),
              (thousands = ','),
              (currency = selected_currency)
            )
              ">
              <img src="@/assets/images/dashboard/Graph-2.svg" />
            </widgetCounter>
            <widgetCounter title="EARNED AMOUNT (Tax excluded)" :value="$formatMoney(
              reports.earned_amount,
              (decimalCount = 2),
              (decimal = '.'),
              (thousands = ','),
              (currency = selected_currency)
            )
              ">
              <img src="@/assets/images/dashboard/Graph-3.svg" />
            </widgetCounter>
          </div>

          <BalancePaymentType :currency="selected_currency"
            :cardAmount="(reports.payed_by_card && reports.payed_by_card.total) || 0"
            :momoAmount="(reports.payed_by_momo && reports.payed_by_momo.total) || 0"
            :spennAmount="(reports.payed_by_spenn && reports.payed_by_spenn.total) || 0">
          </BalancePaymentType>
          </div>
        </div>

        <div class="rigth-panel-body" :class="{ expand: streamTab == 'payed_transations' }"
          v-if="streamTab == 'payed_transations'">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">
              TRANSACTIONS HISTORY ({{ reports.total_payed }})
            </h2>
            <div class="rigth-panel-body-header-actions">
              <b-select v-model="selected_currency" @input="onCurrencyChange" class="filter-currency-input"
                placeholder="Select Currency">
                <option value="RWF">RWF</option>
                <option value="USD">USD</option>
              </b-select>
              <b-button v-if="reports.transactions.length > 0" type="is-default" outlined :loading="loading_download"
                @click="downloadTransationReport()">DOWNLOAD HISTORY</b-button>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="table-widget" v-if="reports.transactions.length > 0">
              <table>
                <tr>
                  <th class="stick-th">Identifier</th>
                  <th class="stick-th">Payed With</th>
                  <th class="stick-th">Amount</th>
                  <th class="stick-th">Eaned</th>
                  <th class="stick-th">Tax</th>
                  <th class="stick-th">Status & Ticket</th>
                  <th class="stick-th">Date</th>
                </tr>
                <template v-for="(item, index) in 15">
                  <tr v-if="loading_transation_report" :key="index">
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                  </tr>
                </template>
                <template v-for="(item, index) in reports.transactions">
                  <tr v-if="!loading_transation_report" :key="index">
                    <td>
                      <div class="transation-content">
                        <b-tooltip v-if="item.payment_type == 'CARD'" :label="`Email:${item.bill_to_email}`"
                          position="is-right">
                          <h3>
                            {{ item.bill_to_first_name + " " + item.bill_to_last_name }}
                          </h3>
                        </b-tooltip>
                        <h3 v-else>
                          {{ item.bill_to_phone
                          }}
                        </h3>
                      </div>

                    </td>

                    <td>{{ item.payment_type }}</td>
                    <td>
                      {{
                        $formatMoney(
                          item.amount,
                          (decimalCount = 2),
                          (decimal = "."),
                          (thousands = ","),
                          (currency = selected_currency)
                        )
                      }}
                    </td>

                    <td>
                      {{
                        $formatMoney(
                          item.earned,
                          (decimalCount = 2),
                          (decimal = "."),
                          (thousands = ","),
                          (currency = selected_currency)
                        )
                      }}
                    </td>

                    <td>
                      {{
                        $formatMoney(
                          item.tax,
                          (decimalCount = 2),
                          (decimal = "."),
                          (thousands = ","),
                          (currency = selected_currency)
                        )
                      }}
                    </td>

                    <td>
                      <b-tooltip :label="`ID:${item.transactionid}`">
                        <b-taglist attached class="tag-lists">
                          <b-tag class="tag-option" type="is-success">PAYED</b-tag>
                          <b-tag class="tag-option" v-if="item.ticket" type="is-dark">{{ item.ticket.ticket_token
                            }}</b-tag>
                        </b-taglist>
                      </b-tooltip>
                    </td>
                    <td>
                      {{
                        moment(item.created_at).format("MMM DD YYYY, h:mm A")
                      }}
                    </td>
                  </tr>
                </template>
              </table>
            </div>

            <widgetNotfound v-if="reports.transactions.length == 0 && !loading_transation_report
            " title="No transactions found" subtitle="No transactions found for this report"></widgetNotfound>
          </div>
        </div>

        <div class="rigth-panel-body" :class="{ expand: streamTab == 'free_tickets' }"
          v-if="streamTab == 'free_tickets'">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">
              INVITATION TICKET HISTORY ({{ reports.freeTickets.length }})
            </h2>
            <div class="rigth-panel-body-header-actions">
              <b-button type="is-primary" outlined @click="showGenelateTicketModal()">GENERATE
                INVITATION</b-button>
              <b-button v-if="reports.freeTickets.length > 0" type="is-default" outlined :loading="loading_download"
                @click="downloadFreeTickets()">EXPORT TICKETS</b-button>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="table-widget" v-if="reports.freeTickets.length > 0">
              <table>
                <tr>
                  <th class="stick-th">Ticket</th>
                  <th class="stick-th">Status</th>
                  <th class="stick-th">Date</th>
                  <th class="stick-th">Action</th>
                </tr>
                <template v-for="(item, index) in 15">
                  <tr v-if="loading_transation_report" :key="index">
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                  </tr>
                </template>
                <template v-for="(item, index) in reports.freeTickets">
                  <tr v-if="!loading_transation_report" :key="index">
                    <td>
                      <div class="transation-content">
                        <h3>
                          {{ item.ticket_token }}
                        </h3>
                      </div>

                    </td>

                    <td>FREE</td>

                    <td>
                      {{
                        moment(item.created_at).format("MMM DD YYYY, h:mm A")
                      }}
                    </td>
                    <td>
                      <b-button type="is-primary" v-clipboard:copy="makeEnvitation(item.ticket_token)"
                        v-clipboard:success="onCopy" v-clipboard:error="onCopyError" outlined>COPY INVITATION</b-button>
                    </td>
                  </tr>
                </template>
              </table>
            </div>

            <widgetNotfound v-if="reports.transactions.length == 0 && !loading_transation_report
            " title="No Free ticket found" subtitle="No free ticket found for this report"></widgetNotfound>
          </div>
        </div>
      </div>
      <div v-else class="rigth-panel">
        <widgetNotfound title="No report" subtitle="Please select a stream to view report"></widgetNotfound>
      </div>
    </div>

    <!-- Genelate ticket Modal -->
    <genelateLiveStreamTicketModal v-if="showGenerateTicketModal" :event="selected_report"
      @saved="onGenerateTicketSuccess" @close="showGenerateTicketModal = false"></genelateLiveStreamTicketModal>
  </div>
</template>

<script>
import genelateLiveStreamTicketModal from "./modals/genelateLiveStreamTicketModal.vue";
import TabsWidget from "./components/TabsWidget.vue";
import BalancePaymentType from "./components/BalancePaymentType.vue";
export default {
  components: {
    genelateLiveStreamTicketModal,
    TabsWidget,
    BalancePaymentType
  },
  sockets: {},
  data: () => ({
    loading_data: false,
    streamed_data: [],
    selected_report: null,
    reports: {
      tax_balance: 0,
      earned_amount: 0,
      total_payed: 0,
      payed_by_card: { total: 0 },
      payed_by_momo: { total: 0 },
      payed_by_spenn: { total: 0 },
      transactions: [],
      freeTickets: [],
    },
    loading_download: false,
    streamTab: 'overview',
    showGenerateTicketModal: false,
    selected_currency: "RWF",
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getPastStreamingReport();
  },
  methods: {
    makeEnvitation(ticketToken) {
      let vm = this;
      let liveEventLink = `${vm.$store.state.SITE_BASE_URL}watch/live/${vm.selected_report.slug}`;
      let envitation_message = "Welcome to our event " + vm.selected_report.title + ".This is your envitation ticket, Open Link below:\n" + liveEventLink + "\n and use ticket (" + ticketToken + ") to watch your event";
      return envitation_message;
    },
    showGenelateTicketModal() {
      let vm = this;
      vm.showGenerateTicketModal = true;
    },
    switchStreamTab(tab) {
      let vm = this;
      vm.streamTab = tab;
    },
    resetSession() {
      let vm = this;
      vm.selected_report = null;
      vm.streamTab = 'overview';
    },
    downloadTransationReport() {
      let vm = this;
      vm.loading_download = true;
      vm.$store
        .dispatch("ADMIN_USER_DOWNLOAD_TRANSATION_REPORT", {
          stream_id: vm.selected_report.id,
          type: "event",
        })
        .then((response) => {
          vm.loading_download = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Report downloaded successfully",
          });
          // Save cvs file from response
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "text/csv",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            vm.selected_report.title + " transactions history report.csv"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.loading_download = false;
          console.log(error);
        });
    },
    downloadFreeTickets() {
      let vm = this;
      vm.loading_download = true;
      vm.$store
        .dispatch("ADMIN_USER_DOWNLOAD_FREE_TICKETS", {
          stream_id: vm.selected_report.id,
          type: "event",
        })
        .then((response) => {
          vm.loading_download = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Tickets downloaded successfully",
          });
          // Save cvs file from response
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "text/csv",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            vm.selected_report.title + " free tickets report.csv"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.loading_download = false;
          console.log(error);
        });
    },
    onCurrencyChange() {
      let vm = this;
      vm.selectReport(vm.selected_report);
    },
    selectReport(item) {
      let vm = this;
      vm.loading_transation_report = true;
      vm.selected_report = item;
      vm.$store
        .dispatch("ADMIN_USER_TRANSATION_REPORT", {
          id: item.id,
          type: "event",
          currency: vm.selected_currency
        })
        .then((response) => {
          vm.loading_transation_report = false;
          vm.reports = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_transation_report = false;
        });
    },
    getPastStreamingReport() {
      let vm = this;
      vm.loading_data = true;
      vm.$store
        .dispatch("ADMIN_USER_STREAMING_REPORT")
        .then((response) => {
          vm.loading_data = false;
          vm.streamed_data = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_data = false;
        });
    },
    onGenerateTicketSuccess() {
      let vm = this;
      vm.showGenerateTicketModal = false;
      vm.selectReport(vm.selected_report);
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Copy successfully!",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./styles/mobile-panel.scss";

.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    justify-content: center;
    align-items: center;
    display: grid;
    grid-template-columns: 25% 75%;
    @include dashboard-wrapper-body-mobile;

    @media (max-width: 768px) {
      grid-template-columns: 35% 65%;
    }

    @media (max-width: 638px) {
      grid-template-columns: 100%;
    }

    .left-panel {
      height: 100%;
      // width: 300px;
      background: #fff;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .streamed-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        border-bottom: 1px solid #ddd;
        padding: 20px 10px;
        cursor: pointer;

        &:hover {
          background: #f5f5f5;
        }

        .streamed-item-image {
          width: 100%;
          height: 100px;
          background: #ddd;
          border-radius: 5px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
            object-fit: cover;
          }
        }

        .streamed-item-content {
          padding-top: 10px;
        }
      }
    }

    .rigth-panel {
      // width: calc(100% - 300px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      overflow-y: auto;
      @include dashboard-right-panel-mobile;

      .rigth-panel-header {
        height: 55px;
        display: flex;
        align-items: center;
        padding: 0px 20px;
        border-bottom: 1px solid #ddd;
        border-top: 1px solid #ddd;
        justify-content: space-between;
        top: 0;
        background: white;

        .tabs-widget {
          display: flex;
          align-items: flex-end;

          .h-spacer {
            margin-right: 20px;
          }

          .tab-item {
            cursor: pointer;
            padding: 14px 4px;
            white-space: nowrap;

            &.active {
              color: var(--wecodefy-secondary-color, #9fc953);
              border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
            }
          }
        }
      }

      .rigth-panel-top {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 10px;
        padding: 10px;

        @media (max-width: 1043px) {
          grid-template-columns: 100%;
        }

      }

      .rigth-panel-body {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;

        &.expand {
          flex: 1;
        }

        .rigth-panel-body-body {
          flex: 1;
          min-height: 0;
          overflow-y: auto;

          .table-widget {
            table {
              width: 100%;

              tr {
                th {
                  white-space: nowrap;
                }

                td {
                  white-space: nowrap;

                  .tag-lists {
                    display: flex;
                    width: fit-content;
                    flex-shrink: 0;
                    min-width: 170px;
                  }
                }
              }
            }
          }

          .stick-th {
            position: sticky;
            top: 0px;
            background: #fff;
            z-index: 1;
            border-bottom: 1px solid #ddd;
          }
        }
      }
    }
  }
}
</style>
